import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import _ from "lodash";

// Internal
import { ActionTypes, GlobalContextData } from "../context";
import { useDocumentTitle } from "./useDocumentTitle";
import { API } from "../constants";
import { ITab } from "../pages/VendorProfileDetails/VendorInfoTypes";
import { useGetService } from "./useGetService";
import { RoutePath } from "../routes";

const shipboardHRProfileTabsData: ITab[] = [
  {
    id: "profile",
    label: "Profile details",
    value: 0,
    completeStatus: false,
  },
  {
    id: "employees",
    label: "Employees",
    value: 3,
    completeStatus: false,
  },
];

export const useShipboardHRProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // Global store using context
  const { state, dispatch } = useContext(GlobalContextData);
  //const vendorType = state?.userInfo?.vendorType;

  useDocumentTitle("Shipboard HR Profile");

  const { response, isLoading, error } = useGetService(
    id && `${API.SHIPBOARD_HR.GET_TRANSPORT_DETAILS_BY_VENDORID}/${id}`
  );

  console.log("useShipboardHRVendorProfile", state, response);
  const [tabs, setTabs] = useState(_.cloneDeep(shipboardHRProfileTabsData));

  const [tab, setTab] = useState<ITab>(tabs[0]);

  useEffect(() => {
    dispatch({
      type: ActionTypes.SET_LOADING,
      payload: {
        isLoading: isLoading,
        loadingText: "Please wait...",
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  useEffect(() => {
    if (response && Object.keys(response).length > 0) {
      dispatch({
        type: ActionTypes.SET_SHIPBOARD_HR_INFO,
        payload: response,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  useEffect(() => {
    const data = [...tabs];

    if (state?.shipboardHRInfo?.shipboardHRDetails?.id) {
      data[0].completeStatus = true;
    }
    if (
      state?.shipboardHRInfo?.vendorEmployees &&
      state?.shipboardHRInfo?.vendorEmployees?.items?.length > 0
    ) {
      data[1].completeStatus = true;
    }

    setTabs(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  useEffect(() => {
    const tabInfo = tabs.find(
      (tabData: ITab) => tabData.id === location.pathname.split("/")[2]
    );
    dispatch({
      type: ActionTypes.HIDE_LEFT_NAVBAR,
      payload: true,
    });
    tabInfo && setTab(tabInfo);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const handleTabChange = (clickedTab: number) => {
    const tabInfo = tabs.find((tabData: ITab) => tabData.value === clickedTab);
    tabInfo && setTab(tabInfo);

    navigate(`/shipboard-hr/${tabInfo?.id}/${id}`);
  };

  const handleBack = () => {
    dispatch({
      type: ActionTypes.HIDE_LEFT_NAVBAR,
      payload: false,
    });
    navigate(RoutePath.DASHBOARD);
  };

  return {
    id,
    location,
    navigate,
    handleTabChange,
    handleBack,
    isLoading,
    error,
    tabs,
    tab,
  };
};
